import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { startsAt: String }

  connect() {
    this.target = new Date(this.startsAtValue).getTime()
    this.update()
    this.timer = setInterval(() => this.update(), 1_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const diff = this.target - Date.now()

    if (diff <= 0) {
      clearInterval(this.timer)
      window.location.reload()
      return
    }

    const totalSeconds = Math.floor(diff / 1_000)
    const days = Math.floor(totalSeconds / 86_400)
    const hours = Math.floor((totalSeconds % 86_400) / 3_600)
    const minutes = Math.floor((totalSeconds % 3_600) / 60)
    const seconds = totalSeconds % 60

    this.daysTarget.textContent = days
    this.hoursTarget.textContent = hours
    this.minutesTarget.textContent = minutes
    this.secondsTarget.textContent = seconds
  }
}
